<template>
  <el-dialog
    append-to-body
    width="800px"
    title="扣取服务费"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
  >
    <div class="content">
      <el-descriptions
        :labelStyle="label_style"
        :contentStyle="content_style"
        title=""
        :column="1"
        border
      >
        <el-descriptions-item label="入职企业">{{
          info.company_name
        }}</el-descriptions-item>
        <el-descriptions-item label="入职日期">{{
          info.entry_date
        }}</el-descriptions-item>
        <el-descriptions-item
          :label="info.work_status == 1 ? '入职凭证' : '离职凭证'"
        >
          <el-image
            v-for="(item, index) in info.refund_img"
            :key="index"
            style="width: 100px; height: 100px"
            :src="item"
            :preview-src-list="info.refund_img"
          >
          </el-image>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <span slot="footer">
      <el-button @click="agree" type="primary">¥500 确定扣款</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
import { checkAmount_ } from "@/util/validator.js";
export default {
  name: "handleRefundDialog",
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      visible2: false,
      loading: false,
      label_style: {
        width: "20%",
      },
      content_style: {
        width: "80%",
      },
      title2: "",
      form: {
        rejectReson: "",
        amount: "",
        image: "",
        fileList: [],
        rules: {
          rejectReson: [
            {
              required: true,
              message: "必填",
              trigger: "change",
            },
          ],
          amount: [
            {
              required: true,
              validator: checkAmount_,
              trigger: "change",
            },
          ],
          image: [
            {
              required: true,
              message: "请上传打款凭证",
              trigger: "change",
            },
          ],
        },
      },
      //预览
      fileList: [],
      dialogImageUrl: "",
      dialogVisibleUrl: false,
      info: { type: "" },
    };
  },
  methods: {
    getDetail(row) {
      this.info = row;
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    reject() {
      this.title2 = "拒绝退款";
      this.visible2 = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form.rejectReson = "";
        this.form.image = "";
        this.form.fileList = "";
      });
    },
    agree() {
      this.$http
        .post("/admin/order/deduct", { id: this.info.id })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.toggle(false);
            this.visible2 = false;
            this.$emit("update");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    reset2() {
      this.form.rejectReson = "";
      this.form.amount = "";
      this.form.image = "";
      this.form.fileList = [];
      this.$refs.form.clearValidate();
      this.visible2 = false;
    },

    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多只能选择 1 个文件`);
    },
    handleAvatarSuccess(event) {
      if (event.code == 1) {
        let list = this.$refs.uploadInvoiceDom.uploadFiles;
        let urlListSuccess = list.filter((i) => i.status == "success");
        let yetList = urlListSuccess.map((item) => item.response);
        this.form.image = yetList.map((item) => {
          return {
            url: item.data.all_path_url,
            name: item.data.name,
          };
        });
        this.$refs.form.clearValidate(["image"]); // 清除 username 字段的校验状态，但不重置值
      } else {
        this.$message({
          type: "error",
          message: event.msg,
        });
      }
    },
    handleRemove() {
      this.form.image = "";
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多只能选择1个文件`);
    },
    lastSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let img = this.form.image
            ? this.form.image.map((item) => item.url).join(",")
            : "";
          let params = {
            id: this.info.id,
            status: this.title2 == "同意退款" ? 1 : 2,
            type: this.info.type,
            refuse_desc: this.form.rejectReson,
            refund_img: img,
          };
          if (params.status == 1) {
            this.$http.post("/admin/order/operation", params).then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.toggle(false);
                this.visible2 = false;
                this.$emit("update");
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$confirm(`请确认${this.title2}?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }).then(() => {
              this.$http.post("/admin/order/operation", params).then((res) => {
                if (res.code == 1) {
                  this.$message.success("操作成功");
                  this.toggle(false);
                  this.visible2 = false;
                  this.$emit("update");
                } else {
                  this.$message.error(res.msg);
                }
              });
            });
          }
        }
      });
    },
    toStr(data, key) {
      return data[key] || "";
    },
    handleCommand(e, row) {
      window.open(row.refund_img[e]);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  overflow: auto;
}
</style>
